import { gsap, Power2, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'


//gsap.fromTo('.fade-opacity-up', {autoAlpha: 0, y: '5vw'}, {duration: 2, ease: Power2.easeOut, autoAlpha: 1, y: 0}, 0);
gsap.fromTo('.fade-opacity-up-intro', {y: 100, x: 10, autoAlpha: 0}, {delay: 1, duration: 1.75, ease: Power4.easeOut, y: 0, x: 0, autoAlpha: 1}, 0);


$(window).on('load', function (){

  let fadeUpElelements = '.animate-fade-up h1, .animate-fade-up h2, .animate-fade-up h3, .animate-fade-up h4, .animate-fade-up h5,' +
    '.animate-fade-up .c-btn, .animate-fade-up p, .animate-fade-up .video-container, .animate-fade-up-block'

  let elements = gsap.utils.toArray(fadeUpElelements)

  elements.forEach((element, i) => {
    const animation = gsap.fromTo(element, {autoAlpha: 0, y: '5vw'}, {duration: 1, ease: Power2.easeOut, autoAlpha: 1, y: 0});
    ScrollTrigger.create({
      trigger: element,
      animation: animation,
      stagger: .2,
      once: true,
      // markers: true
    });

  })


  let lineElements = gsap.utils.toArray('.line-animation')
  lineElements.forEach((element, i) => {
    ScrollTrigger.create({
      trigger: element,
      start: 'top center+=15%',
      end: 'bottom center+=15%',
      onEnter: function () {
        gsap.to(element, { duration: 0.5, ease: 'none', rotateZ: 4 })
      },
      onEnterBack: function () {
        gsap.to(element,  { duration: 0.5, ease: 'none', rotateZ: 0 })
      },
      //markers: true
    });
  })

})


function animateIntro()
{


  gsap.fromTo('.animate-fade-up-slow', {autoAlpha: 0, y: '2vw'}, {duration: 2, ease: Power2.easeOut, autoAlpha: 1, y: 0});


  gsap.fromTo('.animate-fade-up-into-block', {autoAlpha: 0, y: '5vw'}, {duration: 2, ease: Power2.easeOut, autoAlpha: 1, y: 0});


  gsap.fromTo('.bottle-1', {y: 100, x: -10, autoAlpha: 0}, {delay: 1, duration: 0.75, ease: Power4.easeOut, y: 0, x: 0, autoAlpha: 1});
  gsap.fromTo('.bottle-2', {y: 100, x: 10, autoAlpha: 0}, {delay: 1.5, duration: 0.75, ease: Power4.easeOut, y: 0, x: 0, autoAlpha: 1});



}

$(window).on('load', function (e){
  $('.show-after-loading').addClass('fade-opacity-up')
})

export { animateIntro }

